import http from "@/utils/http";
export default {
  //   互联网申报信息
  insertCashInternet (params) {
    return http.post({
      url: "/cash/internet/insertCashInternet",
      data: params,
      resp: true,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    });
  },
  // 獲取驗證碼
  getVerification () {
    return http.get({
      url: "/cash/internet/getVerification"
    });
  },
  // 獲取驗證碼
  getKey () {
    return http.get({
      url: "/cash/internet/getKey"
    });
  },
  // 獲取地址
  getEntryExit (data = "") {
    return http.get({
      url: "/cash/internet/getEntryExit?entryExit=" + data
    });
  },
  // 獲取貨幣名稱
  getCurrency (params) {
    return http.post({
      url: "/cash/internet/getCurrency",
      data: params
    });
  },
  // 獲取國籍
  getCountry (params) {
    return http.post({
      url: "/cash/internet/getCountry",
      data: params
    });
  },
  // 獲取證件類型
  getDictionary (params) {
    return http.post({
      url: "/cash/internet/getCertificates",
      data: params
    });
  },
  getCashInfo (ids) {
    return http.get({
      url: "/cash/internet/listCashInfoByParam?ids=" + ids
    });
  }
};